import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

export interface MobileTabItem {
  value: string;
  label: string;
}

export interface MobileTabsProps {
  value: string;
  items: MobileTabItem[];
  onChange: (value: string) => void;
}

const MobileTabs: React.FC<MobileTabsProps> = ({ value, items, onChange }) => {
  return (
    <Stack
      direction="row"
      sx={{
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
        borderRadius: '8px',
        padding: '2px',
        display: 'flex',
        gap: '2px',
      }}
    >
      {items.map((item) => {
        const isActive = item.value === value;
        return (
          <Box
            key={item.value}
            component="button"
            type="button"
            onClick={() => onChange(item.value)}
            sx={{
              flex: 1,
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              outline: 'none',
              textTransform: 'none',
              fontWeight: isActive ? 500 : 400,
              fontSize: '0.75rem',
              letterSpacing: '0.01em',
              py: '5px',
              px: '14px',
              minWidth: 0,
              color: isActive ? '#0F23DF' : 'rgba(0, 0, 0, 0.65)',
              backgroundColor: isActive ? '#FFFFFF' : 'transparent',
              boxShadow: isActive
                ? '0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06)'
                : 'none',
              transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              '&:hover': {
                backgroundColor: isActive ? '#FFFFFF' : 'rgba(0, 0, 0, 0.05)',
                color: isActive ? '#0F23DF' : 'rgba(0, 0, 0, 0.85)',
                boxShadow: isActive
                  ? '0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)'
                  : 'none',
              },
            }}
            aria-pressed={isActive}
            aria-label={item.label}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 'inherit',
                fontSize: 'inherit',
                color: 'inherit',
                letterSpacing: 'inherit',
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {item.label}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default MobileTabs;
